<template>
  <div>
    <v-card flat>
      <v-card-title>
        <span class="text-h5">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
            hide-details></v-text-field>
          <v-data-table :headers="headers" :items="datos" :items-per-page="5" class="elevation-1" :search="search">
            <template v-slot:item.flag="{ item }">
              <v-icon :color="item.flag ? 'green' : 'red'">
                {{ item.flag ? 'mdi-check-circle' : 'mdi-alert-circle' }}
              </v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small @click="evaluacion(item.id)">mdi-forward</v-icon>
              <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>

        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="cancelAction">
          Volver
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'TablaDatos',
  props: {
    headers: {
      type: Object,
      default: null
    },
    datos: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      search: ''
    }
  },
  methods: {
    cancelAction() {
      this.$emit('closeModal')
    }
  }
}
</script>